import * as React from 'react'

export interface Props {
  id?: string
  onClick: () => Promise<void | boolean>
  className?: string
  disabled?: boolean
  title?: string
  style?: React.CSSProperties
  onWait?: 'replace' | 'prefix' | 'nothing'
  singleClick?: boolean
  singleClickWithMessage?: React.ReactNode
  children?: React.ReactNode
  htmlTag?: 'a' | 'button'
  stopPropagation?: boolean
}

interface State {
  loading: boolean
  fullfilledOnce: boolean
}

export default class AsyncButtonComponent extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = { onWait: 'nothing', htmlTag: 'button' }
  state: State = { loading: false, fullfilledOnce: false }
  unmounted = false

  componentWillUnmount () {
    this.unmounted = true
  }

  private onClickProxy (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) {
    if (this.props.stopPropagation) event.stopPropagation()
    event.preventDefault()

    this.setState({ loading: true })
    void this.props.onClick()
      .then(result => {
        if (!this.props.singleClick) return
        if (typeof result !== 'boolean') throw new Error('onClick() must return a boolean if props.singleClick')
        this.setState({ fullfilledOnce: result })
      })
      .finally(() => !this.unmounted && this.setState({ loading: false }))
    }

  private renderContent () {
    if (this.props.singleClick && this.props.singleClickWithMessage && this.state.fullfilledOnce) return this.props.singleClickWithMessage
    if (!this.state.loading || this.props.onWait === 'nothing') return this.props.children
    if (this.props.onWait === 'replace') return <div className="iconLoading" style={{ display: 'inline-block' }}></div>
    
    if (this.props.onWait === 'prefix') {
      return <div>
        <div className="iconLoading" style={{ float: 'left', margin: '-10px 10px -10px 0' }}></div>
        { this.props.children }
      </div>
    }
    return null
  }

  render () {
    const disabled = this.props.disabled || this.state.loading || (this.props.singleClick && this.state.fullfilledOnce)
    const attributes: React.HTMLAttributes<HTMLButtonElement & HTMLAnchorElement> = {
      id: this.props.id,
      className: this.props.className,
      style: this.props.style,
      title: this.props.title,
      onClick: event => !disabled && this.onClickProxy(event),
      children: this.renderContent()
    }
    
    return this.props.htmlTag === 'a' ? <a { ...attributes } /> : <button { ... attributes } role="button" disabled={ disabled } />
  }
}

export function AsyncLinkComponent (props: Props) {
  return <AsyncButtonComponent { ...props } htmlTag='a' />
}
